import React from 'react'
import CartItem from '../Component/CartItem/CartItem'

function Cart() {
  return (
    <div>
      <CartItem/>
    </div>
  )
}

export default Cart